/* override functions api.jquery.js */
Shopify.onItemAdded = function (line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function (cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
    var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
    jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  }, 2000);
}

Shopify.addItem = function (variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemWithData = function (data, callback) {
  let quantity = data.find(function (item) {
    return item.name === 'quantity';
  });

  if (!quantity) {
    data.push({ name: 'quantity', value: 1 });
  }

  let params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery.param(data),
    dataType: 'json',
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

function removeInputsWithEmptyProperties(data) {
  let isEmptyPropertyTextInput = function (item) {
    let properties = ['Brustumfang', 'Unterbrustumfang', 'Taille', 'Hüftumfang'];
    for (let i = 0; i < properties.length; i++) {
      if (item.name === 'properties[' + properties[i] + ']') {
        return item.value === '';
      }
    }
    return false;
  }

  return data.filter(function (item) {
    return !isEmptyPropertyTextInput(item)
  });
}

function serializeForm(form_id) {
  let $form = $('#' + form_id);
  let data = $form.serializeArray();
  data = removeInputsWithEmptyProperties(data);  
  return jQuery.param(data);
}

function validateInputs(form_id) {
  let $form = $('#' + form_id);
  // Properties that should not be empty if #size-check-checkbox is checked
  if (!$form.find('#size-check-checkbox').is(':checked')) {
    return {
      isValid: true
    }
  }

  let properties = ['Brustumfang', 'Unterbrustumfang', 'Taille', 'Hüftumfang'];

  let isValid = true;
  
  for (let i = 0; i < properties.length; i++) {
    let selector = '[name="properties[' + properties[i] + ']"]';
    let $input = $form.find(selector);
    if ($input.length === 0) {
      continue;
    }

    if ($input.val() === '') {
      $input.siblings('.invalid-feedback').addClass('d-block');
      isValid = false;
    } else {
      $input.siblings('.invalid-feedback').removeClass('d-block');
    }
  }

  return {
    isValid: isValid
  }
}

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  if (!validateInputs(form_id).isValid) {
    return;
  }

  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function () {
      if (form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: serializeForm(form_id),
    dataType: 'json',
    success: function (line_item) {
      if (jQuery('#gutschein-per-post-verschicken')[0] && jQuery('#gutschein-per-post-verschicken')[0].checked) {
        Shopify.addItem('40599314628817', jQuery('.cart-plus-minus-box')[0].value, function justToStopStandardHandling() { });
      }

      // Add silver accessories to cart if checkbox is checked
      if (jQuery('#accessories-silver-checkbox').is(':checked')) {
        let addOnID = $('#accessories-silver-wrapper').data('addon-id');
        
        if (addOnID) {
          let data = [
            {name: 'id', value: addOnID},
            // {name: 'quantity', value: 1},
          ]
    
          let color = $('#productSelect-option-1').val();
          if (color) {
            data.push({name: 'properties[Farbe]', value: color});
          }
    
          Shopify.addItemWithData(data, function justToStopStandardHandling() { });
        }
      }

      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function () {
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
        setTimeout(function () {
          jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
    }
  };

  jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function (form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function (variant_id) {
  var image = jQuery('.' + variant_id + ':first .popup_cart_image').attr("src");
  var title = jQuery('.' + variant_id + ':first .popup_cart_title').text();
  jQuery('.popupimage').attr("src", '' + image + '');
  jQuery('.productmsg').text('' + title + '');
  jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function (variant_id) {
  var image = jQuery('.product_variant_image').attr("src");
  var title = jQuery('#popup_cart_title').text();
  jQuery('.popupimage').attr("src", '' + image + '');
  jQuery('.productmsg').text('' + title + '');
  jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();


      jQuery.each(cart, function (key, value) {
        if (key === 'items') {

          if (value.length == 1) {
            jQuery(".single-product-cart, .item-single-item-count").css({ "display": "block" });
            jQuery(".cart-empty-title, .item-multiple-item-count").css({ "display": "none" });

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }
          else if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({ "display": "block" });
            jQuery(".cart-empty-title,  .item-single-item-count").css({ "display": "none" });

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function (i, item) {
              if (i > 19) {
                return false;
              }
              jQuery('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt="{{ item.img.alt }}" style="width: 90px;"></a><div class="item-close"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="sli sli-close"></i></a></div></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span>' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count").css({ "display": "none" });
            jQuery(".cart-empty-title").css({ "display": "block" });
          }
        }
      });


    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
